export const iconFontAwesomeMediaplaybackHand = (
	<i className="fa-solid fa-hand"></i>
);
